<style>
  #list{
    background-color: white;
    height: 290px;
    width: 290px;
    border: 1px solid rgba(82,119,158,0.16);
    border-radius: 50%;
    position: relative;

  }

  .list-item{
    list-style: none;
    padding: 15px;
    background-color: #FFFFFF;
    border-radius: 50%;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.16);
    position: absolute;
    top: 37%;
    left: 28%;
    transition: all 0.5s;
  }
  @media screen and (min-width: 1025px){
    #list{
      height: 450px;
      width: 450px;
    }
    .list-item{
      padding: 45px;
    }
    .logo-title{
      position: absolute;
      top: 110%;
      color: #004373;
      font-size: 18px;
      font-weight: 500;
      letter-spacing: 2px;
      line-height: 21px;
      text-align: center;
      display: block!important;
    }
  }
  .logo-title{
    display: none;
  }
  .active{
    background-color: #F99337;
  }

  #serviceContent{
    color: #8A8A8A;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 24px;
  }
  li{
    cursor: pointer;
  }

  .transport, .logistiek, .leeggoed, .administratie, .magazijnbeheer, .active > img{
    width: 48px!important;
    height: 48px!important;
  }
  #serviceImage {
    height: 60px;
    width: 56px;
  }
</style>

<template>
  <div class="flex flex-wrap items-center lg:justify-between">
    <div data-aos="fade-right" data-aos-duration="500" class="w-full lg:w-7/12 md:mb-80 flex justify-center items-center mt-40 lg:mt-80">
      <ul id="list">
        <li v-for="(service, key) in data.services_array" class='list-item flex justify-center' @click="activateService(key)">
          <img src="/svg/transport.svg" class="transport" alt="" v-if="service.symbol == 'transport'">
          <p class="logo-title">{{service.title}}</p>
          <img src="/svg/logistiek.svg" class="logistiek" alt="" v-if="service.symbol == 'logistiek'">
          <img src="/svg/leeggoedafhandeling.svg" class="leeggoed" alt="" v-if="service.symbol == 'leeggoed'">
          <img src="/svg/administratie.svg" class="administratie" alt="" v-if="service.symbol == 'administratie'">
          <img src="/svg/magazijnbeheer.svg" class="magazijnbeheer" alt="" v-if="service.symbol == 'magazijnbeheer'">
        </li>
      </ul>
    </div>

    <div data-aos="fade-left" class="w-full lg:w-4/12 mt-40 l:mb-0">
      <img  id="serviceImage" alt="Vario Food service">
      <h3 class="text-32 font-bold mt-16 tracking-normal text-secondary" id="serviceTitle"></h3>
      <p id="serviceContent" class="mt-16 mb-40"></p>
      <button class="left-button" @click="changeKey(activeKey--)"></button>
      <button class="right-button" @click="changeKey(activeKey++)"></button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeKey: 0,
      totalKeys: 0,
      keys : []
    };
  },

  props: {
    data: {
      type: Object,
      required: true
    },
  },

  methods:{

    // function to dynamically determine the placing of the service item
    placeServices: function() {
      const items = document.getElementsByClassName('list-item');
      var arr = Array.prototype.slice.call( items );
      const screenWidth =  window.screen.width;
      var translateOffset = '-140px';
      if(screenWidth > 1024){
        translateOffset = '-225px';
      }
      this.totalKeys = arr.length - 1;
      this.keys = arr;

      var i = 0;
      arr.forEach(function (item){
        var offsetAngle = 360 / arr.length;
        var rotateAngle = offsetAngle * i;
        item.style.transform = "rotate(" + rotateAngle + "deg) translate(0," + translateOffset + ") rotate(-" + rotateAngle + "deg)";
        i++;
      })

      // add first element active class and content
      arr[0].classList.add('active')
      const activeSymbol = document.getElementsByClassName('active')[0];
      activeSymbol.getElementsByTagName('img')[0].src = '/svg/transport-white.svg'
      this.whiteImage(activeSymbol)

      this.changeImage(this.data.services_array[0]);
      document.getElementById('serviceTitle').innerText = this.data.services_array[0].title.replace(/(<([^>]+)>)/gi, "");
      document.getElementById('serviceContent').innerText = this.data.services_array[0].description.replace(/(<([^>]+)>)/gi, "");
    },

    // switch through services
    changeKey(activeKey){
      if(this.activeKey >= this.totalKeys + 1 ){
        this.activeKey = 0
      }
      if(this.activeKey < 0){
        this.activeKey = this.totalKeys
      }
        this.keys.forEach(item => {
          if (item.classList.contains('active'))
            item.classList.remove('active')
            this.activeImage(item)
        });
        this.keys[this.activeKey].classList.add('active')
        this.whiteImage(this.keys[this.activeKey])

        this.changeImage(this.data.services_array[this.activeKey])
        document.getElementById('serviceContent').innerText = this.data.services_array[this.activeKey].description.replace(/(<([^>]+)>)/gi, "");
        document.getElementById('serviceTitle').innerText = this.data.services_array[this.activeKey].title.replace(/(<([^>]+)>)/gi, "");
    },

    // activate service on click
    activateService(key){
      this.keys.forEach(item => {
        if (item.classList.contains('active'))
          item.classList.remove('active')
        this.activeImage(item)
      });

      this.keys[key].classList.add('active')
      this.whiteImage(this.keys[key])

      this.changeImage(this.data.services_array[key])

      document.getElementById('serviceTitle').innerText = this.data.services_array[key].title.replace(/(<([^>]+)>)/gi, "");

      document.getElementById('serviceContent').innerText = this.data.services_array[key].description.replace(/(<([^>]+)>)/gi, "");
    },

    // active state image switch
    activeImage(item){
      if(item.getElementsByTagName('img')[0].classList.contains('administratie')){
        item.getElementsByTagName('img')[0].src = '/svg/administratie.svg'
      }
      if(item.getElementsByTagName('img')[0].classList.contains('transport')){
        item.getElementsByTagName('img')[0].src = '/svg/transport.svg'
      }
      if(item.getElementsByTagName('img')[0].classList.contains('leeggoed')){
        item.getElementsByTagName('img')[0].src = '/svg/leeggoedafhandeling.svg'
      }
      if(item.getElementsByTagName('img')[0].classList.contains('logistiek')){
        item.getElementsByTagName('img')[0].src = '/svg/logistiek.svg'
      }
      if(item.getElementsByTagName('img')[0].classList.contains('magazijnbeheer')){
        item.getElementsByTagName('img')[0].src = '/svg/magazijnbeheer.svg'
      }
    },
    whiteImage(item){
      if(item.getElementsByTagName('img')[0].classList.contains('administratie')){
        item.getElementsByTagName('img')[0].src = '/svg/administratie-white.svg'
      }
      if(item.getElementsByTagName('img')[0].classList.contains('transport')){
        item.getElementsByTagName('img')[0].src = '/svg/transport-white.svg'
      }
      if(item.getElementsByTagName('img')[0].classList.contains('leeggoed')){
        item.getElementsByTagName('img')[0].src = '/svg/leeggoedafhandeling-white.svg'
      }
      if(item.getElementsByTagName('img')[0].classList.contains('logistiek')){
        item.getElementsByTagName('img')[0].src = '/svg/logistiek-wit.svg'
      }
      if(item.getElementsByTagName('img')[0].classList.contains('magazijnbeheer')){
        item.getElementsByTagName('img')[0].src = '/svg/magazijnbeheer-white.svg'
      }
    },
    // change image on click/buttons
    changeImage(item){
      if(item.symbol == 'logistiek'){
        document.getElementById('serviceImage').src = ('/svg/logistiek.svg')
      } else if(item.symbol == 'transport'){
        document.getElementById('serviceImage').src = ('/svg/transport.svg')
      }else if(item.symbol == 'leeggoed') {
        document.getElementById('serviceImage').src = ('/svg/leeggoedafhandeling.svg')
      }else if(item.symbol == 'administratie') {
        document.getElementById('serviceImage').src = ('/svg/administratie.svg')
      }else if(item.symbol == 'magazijnbeheer') {
        document.getElementById('serviceImage').src = ('/svg/magazijnbeheer.svg')
      }
    }
  },

  mounted(){
    this.placeServices()
  },
}
</script>